import React from "react";
import { Link } from "react-router-dom";
import { BASE_URL, APP_EVENT_ID, XCHANGE_PLATFORM_NAME } from "../utils/consts";
import { USER_ROLES } from "./UserProvider";
import styles from "./LeaveMeetingButton.module.css";

const LEAVE_MEETING_TOOLTIP = "Leave Meeting";

const LeaveMeetingButton = ({ userRole, companyId, onClick = () => {} }) => {
  const buttonIcon = (
    <React.Fragment>
      <span
        title={LEAVE_MEETING_TOOLTIP}
        className={`${styles.leaveWherebyMeetingIcon} fas fa-sign-out-alt`}
      ></span>
      <span className={styles.leaveWherebyMeetingText}>Leave</span>
    </React.Fragment>
  );

  const handleOnClick = () => {
    console.log("[LeaveMeetingButton] handleOnClick");
    onClick();
  };

  return userRole === USER_ROLES.DELEGATE ? (
    <a
      href={`${BASE_URL}/${XCHANGE_PLATFORM_NAME}/${APP_EVENT_ID}/calendar/`}
      className={styles.leaveWherebyMeetingButton}
      onClick={handleOnClick}
    >
      {buttonIcon}
    </a>
  ) : userRole === USER_ROLES.RECEPTIONIST ? (
    <a
      href={`${BASE_URL}`}
      className={styles.leaveWherebyMeetingButton}
      onClick={handleOnClick}
    >
      {buttonIcon}
    </a>
  ) : (
    <Link
      to={`/${companyId}/home`}
      className={styles.leaveWherebyMeetingButton}
    >
      {buttonIcon}
    </Link>
  );
};

export default LeaveMeetingButton;
